import { render, staticRenderFns } from "./setting-manage.vue?vue&type=template&id=36a0c6e4&scoped=true"
import script from "./setting-manage.vue?vue&type=script&lang=js"
export * from "./setting-manage.vue?vue&type=script&lang=js"
import style0 from "./setting-manage.vue?vue&type=style&index=0&id=36a0c6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0c6e4",
  null
  
)

export default component.exports